<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="项目名称">
          <el-input v-model="formInline.cproname" placeholder="项目名称"></el-input>
        </el-form-item>

        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetInvoiceList" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <div class="text item text-center">
        <div class="pull-right" style="margin-bottom:15px"></div>
        <el-table :data="orderlist" style="width: 100%" max-height="480" border :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ padding: '7px 0',textAlign: 'center'}" @current-change="clickChange">

          <el-table-column prop="cprocode" label="项目编号" min-width="200"></el-table-column>
          <el-table-column prop="cproname" label="项目名称" min-width="200"></el-table-column>
          <el-table-column prop="cbankname" label="标段（包）名称" min-width="200"></el-table-column>
          <el-table-column prop="cnote" label="项目节点" width="160"></el-table-column>

          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="addoption(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>

      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        cproname: "",
      },

      tableRadio: {
        cddatasource: "",
        cexch_name: "人民币",
        cvouchtype: "纸质发票",
        cfpcode: "",
        cinportop: "",
        companyname: "",
        cpasturecode: "",
        cpasturename: "",
        cpbvcode: "",
        cpbvmemo: "",
        CreateDate: "",
        CreateUserId: "",
        CreateUserName: "",
        csapcode: "",
        cstatus: "",
        cvencode: JSON.parse(localStorage.getItem("userdata")).ccustomercode,
        cvenname: JSON.parse(localStorage.getItem("userdata")).ccustomername,
        cztcode: "",
        dinportdate: "",
        dpbvdate: "",
        iexch_rate: 1,
        iinport: "",
        itaxmoney: 0,
        itotalmoney: 0,
        itotalqty: "",
        iu8pbvid: "",
        ModifyDate: "",
        ModifyUserId: "",
        ModifyUserName: "",
      },

      orderlist: [],
      prinpageif: false,
      prinpagesrc: "",
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.GetInvoiceList();
  },
  methods: {
    addoption(val) {
      this.tableRadio = val;
      this.$router.push({
        name: "Invitationedit",
        params: { tableRadio: this.tableRadio },
      });
    },
    // 获取订单
    GetInvoiceList() {
      this.$axios({
        method: "post",
        url: "/CommonModule/Op_Supplier/GetOp_Proinfo",
        data: {
          cproname: this.formInline.cproname,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.totalCount = res.data.Data.totalCount;
          this.orderlist = res.data.Data.rows;
        }
      });
    },

    clickChange(item) {
      this.tableRadio = item;
    },

    printclose(val) {
      this.prinpageif = val;
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInvoiceList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInvoiceList();
    },
  },
};
</script>
